module.exports = __webpack_public_path__ + "assets/img/index-partner29.52b723e4.jpg";